// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style.scss
// module id = 7
// module chunks = 0